import { render, staticRenderFns } from "./QuickLink.vue?vue&type=template&id=096b8c98&scoped=true"
import script from "./QuickLink.vue?vue&type=script&lang=js"
export * from "./QuickLink.vue?vue&type=script&lang=js"
import style0 from "./QuickLink.vue?vue&type=style&index=0&id=096b8c98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b8c98",
  null
  
)

export default component.exports